module.exports = __webpack_public_path__ + "img/sld_mfm_invs_1_dark.dc7ff087.svg";